import { Component, Input } from '@angular/core';
import { OverlayComponent } from '@overlays/overlay/overlay.component';
import { User } from '@services/user.interface';
import { NgStyle } from '@angular/common';
import { AvatarComponent } from '../../components/avatar/avatar.component';

@Component({
  selector: 'app-welcome-overlay',
  templateUrl: './welcome-overlay.component.html',
  styleUrls: ['./welcome-overlay.component.scss'],
  imports: [NgStyle, AvatarComponent],
})
export class WelcomeOverlayComponent extends OverlayComponent {
  @Input() message: string;
  @Input() user: User;
  avatarStyles: { [key: string]: string } = {};
  id = 'welcome-overlay';
  /**
   * Returns a greeting based on the current time of day
   * @returns {string} A personalized greeting message
   */
  getUserGreeting(): string {
    let greeting = 'Good morning';
    // TODO: Maybe use dayjs
    const currentHourOfDay = new Date().getHours();
    if (currentHourOfDay >= 12 && currentHourOfDay < 18) {
      greeting = 'Good afternoon';
    } else if ((currentHourOfDay >= 18 && currentHourOfDay <= 24) || (currentHourOfDay >= 1 && currentHourOfDay <= 3)) {
      greeting = 'Good evening';
    }
    if (this.user?.name) {
      return (greeting += `, ${this.user.name}!`);
    } else {
      return greeting;
    }
  }

  /**
   * Update the overlay styles based on the viewport size
   */
  override updateOverlayStyles(): void {
    const { playerWidth = 0, playerHeight = 0, browserHeight = 0, browserWidth = 0 } = this.viewportSize || {};

    // Calculate dimensions and position
    let overlayWidth: number | string;
    let leftPosition: number | string;
    let topPosition: number | string;
    let calcFontSize: number | string;

    // NOTE: Check if browser height is really big or when the
    // browser winodw is narrow. Adjust the overlay to mat
    // the smaller player height and widths.
    if (browserHeight > browserWidth) {
      overlayWidth = Math.floor(playerWidth * 0.85);
      leftPosition = Math.floor((browserWidth - overlayWidth) / 2);
      topPosition = Math.floor(playerHeight * 0.6);
      calcFontSize = `3vw`;
    } else {
      overlayWidth = Math.floor(browserWidth * 0.95);
      leftPosition = Math.floor((browserWidth - overlayWidth) / 2);
      topPosition = Math.floor(playerHeight * 0.65);
      calcFontSize = `3vw`;
    }

    this.overlayStyles = {
      position: 'absolute',
      top: `${topPosition}px`,
      left: `${leftPosition}px`,
      width: `${overlayWidth}px`,
      height: `fit-content`,
      fontSize: calcFontSize,
    };
  }
}
